export default __webpack_public_path__ + "images/models/dd7e7bdb0a64b4fac50a47fbccbc298d.glb";